import { render, staticRenderFns } from "./Casts.vue?vue&type=template&id=773c9233&"
import script from "./Casts.vue?vue&type=script&lang=js&"
export * from "./Casts.vue?vue&type=script&lang=js&"
import style0 from "./Casts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/landun/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('773c9233')) {
      api.createRecord('773c9233', component.options)
    } else {
      api.reload('773c9233', component.options)
    }
    module.hot.accept("./Casts.vue?vue&type=template&id=773c9233&", function () {
      api.rerender('773c9233', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/page/summary/components/Casts.vue"
export default component.exports